import { useField, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { GoTrash } from 'react-icons/go';
import { IoImageOutline } from 'react-icons/io5';

const FileUpload = ({ field, form, containerClassName, uploadContainerClass, name, ...props }: any) => {
  const { setFieldValue } = useFormikContext();
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    // Generate a preview whenever a new file is selected
    if (field.value && !field.value?.url) {
      const reader: any = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(field.value);
    } else {
      setPreview(null);
    }
  }, [field.value]);

  const handleRemove = () => {
    setFieldValue(field?.name, null);
  };

  return (
    <section className={`flex flex-col ${containerClassName}`}>
      {field.value?.url && (
        <div
          className={`w-full rounded-lg flex items-center justify-center relative min-h-[150px] h-[150px] ${uploadContainerClass}`}
        >
          <img src={field.value?.url} alt='Preview' className='object-cover h-full w-full rounded-lg' />
          <section
            onClick={handleRemove}
            className='absolute bottom-0 text-xs justify-center left-0 w-full text-bg-gradient min-h-[30px] flex items-center rounded-bl-lg rounded-br-lg'
          >
            <GoTrash className='mr-1' /> <span>Remove</span>
          </section>
        </div>
      )}
      {preview && (
        <div
          className={`w-full rounded-lg flex items-center justify-center relative min-h-[150px] h-[150px] ${uploadContainerClass}`}
        >
          <img src={preview} alt='Preview' className='object-cover h-full w-full rounded-lg' />
          <section
            onClick={handleRemove}
            className='absolute bottom-0 text-xs justify-center left-0 w-full text-bg-gradient min-h-[30px] flex items-center rounded-bl-lg rounded-br-lg'
          >
            <GoTrash className='mr-1' /> <span>Remove</span>
          </section>
        </div>
      )}

      {!preview && !field.value?.url && (
        <div className={`flex items-center justify-center w-full min-h-[150px] h-[150px] ${uploadContainerClass}`}>
          <label
            htmlFor='dropzone-file'
            className='flex flex-col items-center justify-center w-full h-full border-gray-300 border-dashed rounded-lg cursor-pointer bg-card'
          >
            <div className='flex flex-col items-center justify-center pt-5 pb-6 w-full h-full'>
              <IoImageOutline className='text-3xl text-neutral-600' />
              <p className='mt-2 text-xs text-neutral-600'>Upload image</p>
            </div>
            <input
              id='dropzone-file'
              type='file'
              className='hidden'
              accept='image/png, .svg, .jepg, .jpg'
              onChange={(e) => {
                // Object is possibly null error w/o check
                if (e.currentTarget.files) {
                  form.setFieldValue('image', e.currentTarget.files[0]);
                }
              }}
            />
          </label>
        </div>
      )}
    </section>
  );
};

export default FileUpload;
